// extracted by mini-css-extract-plugin
export var tosLink = "_73-0";